// extracted by mini-css-extract-plugin
export default {"Projects":"Projects_Projects__Ifx1t","Bottom":"Projects_Bottom__Ua-Ab","Header":"Projects_Header__du6kU","MainDiv":"Projects_MainDiv__stV3p"};